import React, { useState } from 'react';
import { basicFormValidationHandler } from '../../utils';
import { isEmpty } from 'lodash';
import InputField from '../Reusable/InputField';
import { Row, Col } from 'react-bootstrap';
import FormWrapper from '../Reusable/FormWrapper/FormWrapper.js';
import ComboBoxAutocomplete from '../Reusable/ComboBoxAutocomplete';

const ChannelForm = (props) => {
  const { saveHandler, translations, channelForUpdate, enums } = props || {},
    {
      Placeholders,
      Errors
    } = translations || {};

  const [errors, setErrors] = useState({});

  const [state, setState] = useState({
    channelId: channelForUpdate?.channelId || null,  
    name: channelForUpdate?.name || null,
    source: channelForUpdate?.source
      ? enums.ChannelSource[channelForUpdate?.source]
      : null,
    status: channelForUpdate?.status
      ? enums.ChannelStatus[channelForUpdate?.status]
      : null
  });  

  const onChangeHandler = (event) => {
    changeState(event.target.name, event.target.value);
  };

  function changeState(propName, value) {
    setState((prevState) => ({ ...prevState, [propName]: value }));
  }

  const clientValidationHandler = () => { 
    const {name, source, status} = state;
    const errorsObject = basicFormValidationHandler({name, source, status}, Errors);    
    setErrors(errorsObject);
    return !isEmpty(errorsObject);  

  };

  const onSubmitHandler = (event) => {
    event?.preventDefault();
    if (clientValidationHandler()) {
      return;
    }
    const {
      source,
      status      
    } = state || {};
    const channelForSave = {
      ...channelForUpdate,
      ...state,     
      source: source?.value,
      status: status?.value
    };
    saveHandler(channelForSave);   
  };

  const sources = Object?.values(enums.ChannelSource);
  const statuses = Object?.values(enums.ChannelStatus); 

  return (
    <FormWrapper
      submitRef={props.submitRef}
      noValidate={true}
      onSubmit={onSubmitHandler}
    >
      <Row md={12}>
        <Col md={6} className="m-auto">
          <InputField
            id="channelId"
            name="channelId"
            placeholder={Placeholders.channelId}
            onChange={onChangeHandler}
            value={state.channelId}
            error={errors}
            errorsHandler={setErrors}           
          />
        </Col>
      </Row>
      <Row md={12}>
        <Col md={6} className="m-auto">
          <InputField
            id="name"
            name="name"
            placeholder={Placeholders.name}
            onChange={onChangeHandler}
            value={state.name}
            error={errors}
            errorsHandler={setErrors}
            required
          />
        </Col>
      </Row>
      <Row md={12}>
        <Col md={6} className="m-auto">
          <ComboBoxAutocomplete
            id="source"
            data={sources}
            textExtractor={(a) => a?.text}
            changeValue={(newValue) => {
              changeState('source', newValue);
            }}
            label={Placeholders?.source}
            updateValue={state?.source}
            required
            error={errors}
            errorsHandler={setErrors}
            filterSelectedOptions
          />
        </Col>
      </Row>
      <Row md={12}>
        <Col md={6} className="m-auto">
          <ComboBoxAutocomplete
            id="status"
            data={statuses}
            textExtractor={(a) => a?.text}
            changeValue={(newValue) => {
              changeState('status', newValue);
            }}
            label={Placeholders?.status}
            updateValue={state?.status}
            required
            error={errors}
            errorsHandler={setErrors}
            filterSelectedOptions
          />
        </Col>
      </Row>
    </FormWrapper>
  );
};

export default ChannelForm;
